import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectFabricationDataForPrices } from 'taiwan_pcb/pcb_fabrication/slice/selectors';
import { priceSelected } from 'taiwan_pcb/pcb_fabrication/slice/fabricationSlice';
import {
  CAN_NOT_QUOTE_AUTOMATICALLY,
  ERROR,
  // PRICE_SELECTED,
  // QUOTED,
  QUOTING,
  START,
} from 'shared/data/quoteSteps';

import PriceMatrix from 'shared/components/price/PriceMatrix';
import AutomaticQuoteError from 'shared/components/AutomaticQuoteError';
import CantQuoteAutomatically from 'shared/components/CantQuoteAutomatically';
import QuoteActionBar from 'taiwan_pcb/pcb_fabrication/components/QuoteActionBar';

const Prices = () => {
  const dispatch = useDispatch();
  const {
    quote,
    quoteStep,
    parameters,
    parametersChanged,
  } = useSelector(selectFabricationDataForPrices);

  const onPriceSelect = (data) => dispatch(priceSelected(data));
  // const onSendEmailQuote = (data, token) => dispatch(doEmailQuote({ data, token }));

  const lineItem = quote?.line_items[0];

  if (quoteStep === ERROR) {
    return <AutomaticQuoteError />;
  }

  if (quoteStep === CAN_NOT_QUOTE_AUTOMATICALLY) {
    return <CantQuoteAutomatically />;
  }

  return (
    <div className="container-fluid quote-result">
      <div className="row">
        <div className="col-md-12">
          {quoteStep !== QUOTING && <QuoteActionBar />}
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <PriceMatrix
            tableStripe
            lineItem={lineItem}
            parametersChanged={parametersChanged}
            onPriceSelect={onPriceSelect}
            parameters={parameters}
            quoteStep={quoteStep} />
        </div>
      </div>
      {/* {quoteStep === START && <PcbInstructions />}
      {[QUOTED, PRICE_SELECTED].includes(quoteStep) && <Terms />} */}
    </div>
  );
};

export default Prices;